import { format, formatDistanceStrict, formatDistanceToNow } from 'date-fns';
import { enUS, sv } from 'date-fns/locale';

export function friendlyDateTime(value: any, seconds = true): string {

    if (!value) {

        return '';
    }

    const date = new Date(value);

    if (seconds) {

        return format(date, 'yyyy-MM-dd HH:mm:hh', { locale: sv });
    }

    return format(date, 'yyyy-MM-dd HH:mm', { locale: sv });
}

export function friendlyDistance(value: any, localeAlias = 'sv'): string {

    if (!value) {

        return '';
    }

    const locale = localeAlias === 'sv' ? sv : enUS;

    const date = new Date(value);

    return formatDistanceToNow(date, { addSuffix: false, includeSeconds: true, locale });
}

export function friendlyDistanceStrict(value: any, localeAlias = 'sv'): string {

    if (!value) {

        return '';
    }

    const locale = localeAlias === 'sv' ? sv : enUS;

    const date = new Date(value);

    return formatDistanceStrict(date, new Date(), { locale, addSuffix: false });
}
